import React, { useState } from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { Button, Stack, Typography } from '@mui/material';
import { DateFormats } from 'constants/common';
import { RotateLeft } from '@mui/icons-material';
import { Listing } from 'components/shared/TableListing';

import { changeLogListingColumns } from './listingConfig';
import { CreditSubmissionChangeLogTableRow } from '../types';
import {
  creditSubmissionChangelogApi,
  GetCreditSubmissionChangelogResponse,
  GetCreditSubmissionChangelogVariables,
} from '../api';

interface Props {
  csId: string;
}

export const ChangeLogListing = ({ csId }: Props) => {
  const [pagination, setPagination] = useState({ page: 1, perPage: 10 });

  const { data, previousData, loading, refetch } = useQuery<
    GetCreditSubmissionChangelogResponse,
    GetCreditSubmissionChangelogVariables
  >(creditSubmissionChangelogApi.getCreditSubmissionChangelog, {
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        pagination,
        creditSubmissionId: csId,
      },
    },
  });

  const tableData = (data?.result?.items ?? previousData?.result?.items ?? []).map(log => ({
    id: log.id,
    changes: log.changes,
    changeType: log.changeType,
    modifiedBy: log.modifiedBy?.fullName ?? '—',
    actorType: log.modifiedBy?.account?.portalType ?? '—',
    createdDateTime: moment(log.createdDateTime).format(DateFormats.DateTimeMedium24Hour),
  }));

  return (
    <Listing<CreditSubmissionChangeLogTableRow>
      loading={loading}
      tableData={tableData}
      columns={changeLogListingColumns}
      pagination={{
        ...pagination,
        total: data?.result?.pagination?.total ?? 0,
        onChange: nextValue => setPagination(prev => ({ ...prev, page: nextValue })),
      }}
      actionPanelTop={() => (
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <Typography variant="subtitle2">Change Log</Typography>

          <Button
            size="small"
            color="primary"
            loading={loading}
            startIcon={<RotateLeft />}
            onClick={async () => {
              await refetch();
            }}
          >
            Refresh
          </Button>
        </Stack>
      )}
    />
  );
};
